
import { IUsersTranslations } from '../';

const users: IUsersTranslations = {
  name: 'Name',
  email: 'Email',
  users: 'Users',
  phone: 'Phone number',
  deleteUsers: 'Wipe users',
  delete_users_confirm: 'Are you sure you want to permanently delete the selected users? Only for accounts with no activity, such as test accounts. For data protection requests use Erase user instead. This action cannot be undone.',
  erase_action: 'Erase user (GDPR)',
  erase_title: 'Erase this account',
  erase_hint: 'Use this for data protection requests. Once erased:',
  erase_effect_locked_out: 'They can no longer sign in, and we stop contacting them. Their email and login phone are freed and can be used for a new account.',
  erase_effect_profile_removed: 'Their profile (name, phone, birthdate, location, preferences) is removed.',
  erase_effect_records_kept: 'Purchases, invoices, tickets and event registrations are kept for organisers and accounting.',
  erase_checking: 'Checking whether this account can be erased…',
  erase_check_failed: 'Could not check this account',
  erase_blocked_title: 'This account cannot be erased yet:',
  erase_blocker_is_staff: 'Staff accounts cannot be erased.',
  erase_blocker_already_erased: 'This account was already erased.',
  erase_blocker_holds_upcoming_tickets: 'Holds tickets for events that have not ended. They must be transferred to someone else first.',
  erase_blocker_sole_manager_of_upcoming_event: 'Is the only manager of events that have not ended. Add another manager first.',
  erase_ticket_refs: 'Tickets:',
  erase_event_refs: 'Events:',
  erase_recheck: 'Check again',
  erase_reason: 'Reason or request reference',
  erase_reason_placeholder: 'e.g. support ticket #1234',
  erase_confirm_label: 'Type the user\'s email to confirm',
  erase_submit: 'Erase account',
  erase_success: 'Account erased',
  erase_failed: 'Could not erase this account',
};

export default users;
